import { questions } from '../mocks/questions.ts';

export function calculateDoshas(answers: Record<number, number>) {
  const names = ['vata', 'pitta', 'kapha'] as const;
  const scores = { vata: 0, pitta: 0, kapha: 0 };
  for (const q of questions) {
    const value = answers[q.id];
    if (!Number.isInteger(value) || value < 1 || value > 5) {
      throw new Error('Responda a todas as perguntas antes de concluir.');
    }
    scores[q.dosha] += value;
  }
  const total = scores.vata + scores.pitta + scores.kapha;
  const shares = names.map(name => ({ name, raw: scores[name] * 100 / total }));
  const percentages = Object.fromEntries(shares.map(s => [s.name, Math.floor(s.raw)]));
  const remainder = 100 - Object.values(percentages).reduce((a, b) => a + b, 0);
  [...shares].sort((a, b) => (b.raw % 1) - (a.raw % 1)).slice(0, remainder)
    .forEach(s => percentages[s.name]++);
  const ranked = [...names].sort((a, b) => scores[b] - scores[a]);
  return {
    vata: { score: scores.vata, percent: percentages.vata },
    pitta: { score: scores.pitta, percent: percentages.pitta },
    kapha: { score: scores.kapha, percent: percentages.kapha },
    dominant: ranked[0],
    dominants: ranked.filter(name => percentages[ranked[0]] - percentages[name] <= 10),
  };
}

export function readProgress(raw: string | null) {
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (!data || typeof data.answers !== 'object' || !data.answers) return null;
    const answers: Record<number, number> = {};
    for (const q of questions) {
      const value = data.answers[q.id];
      if (Number.isInteger(value) && value >= 1 && value <= 5) answers[q.id] = value;
    }
    const firstMissing = questions.findIndex(q => answers[q.id] === undefined);
    const maxIndex = firstMissing === -1 ? questions.length - 1 : firstMissing;
    const requested = Number.isInteger(data.currentQuestion) ? data.currentQuestion : maxIndex;
    return { answers, currentQuestion: Math.max(0, Math.min(requested, maxIndex)) };
  } catch { return null; }
}
